"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectScenario = selectScenario;
exports.selectModule = selectModule;
exports.selectPresentationBlocks = selectPresentationBlocks;
exports.selectPresentationBlock = selectPresentationBlock;
exports.selectIsNowPresentationBlock = selectIsNowPresentationBlock;

var _constants = require("../constants");

function selectModule(state) {
  return state[_constants.SCENARIO_MODULE_NAME];
}

function selectScenarioState(state) {
  return selectModule(state).scenario;
}

function selectScenario(state) {
  return selectScenarioState(state).data;
}

function selectPresentationBlocks(state) {
  return selectScenario(state).presentationBlocks;
}

function selectPresentationBlock(state, stage) {
  var presentationBlocks = selectPresentationBlocks(state);

  if (!presentationBlocks[stage]) {
    return null;
  }

  return presentationBlocks[stage];
}

function selectIsNowPresentationBlock(state, stage) {
  var presentationBlocks = selectPresentationBlocks(state);
  return presentationBlocks[stage];
}